import i18n from 'src/modules/locales/utils/i18nInit';
import { GAME_ORIGIN } from '../../../config';
import { GPTGameNameType } from '../../../types';

export const postShowRequest = (gameFrame: HTMLIFrameElement, gameName: GPTGameNameType) => {
  const sessionId = localStorage.getItem('accessToken') || null;

  const data = JSON.stringify({
    sessionId,
    language: i18n.language
  });

  gameFrame.contentWindow?.postMessage(
    {
      type: 'SHOW_REQUEST',
      gameName,
      data
    },
    GAME_ORIGIN
  );
};
